import type { Profile } from 'models';
import { useTranslation } from 'react-i18next';
import { Checkbox, Form } from 'ui';

const NotificationCheckbox = ({
  area,
  heading,
  type,
  user,
}: {
  area: 'enableNotifications' | 'events' | 'giving' | 'messaging' | 'newsfeed' | 'program';
  heading: string;
  type: 'email' | 'push';
  user: Profile;
}) => {
  const { t } = useTranslation();
  const notificationType: 'emailNotificationsSettings' | 'pushNotificationsSettings' = `${type}NotificationsSettings`;
  const notificationTypeUserKey: 'emailNotificationsSettings' | 'pushNotificationsSettings' =
    `${type}NotificationsSettings`;

  const getAriaLabel = () => {
    switch (type) {
      case 'email':
        return t('email notifications settings for', { value: t(heading) });
      case 'push':
        return t('push notifications settings for', { value: t(heading) });
    }
  };

  return (
    // eslint-disable-next-line no-restricted-syntax -- TODO: fix later
    <Form.Item dependencies={[[notificationType, 'enableNotifications']]} noStyle>
      {({ getFieldValue }) => {
        const isDisabled =
          !getFieldValue([notificationType, 'enableNotifications']) ||
          !user[notificationTypeUserKey]?.[area]?.changeAllowed;

        return (
          // eslint-disable-next-line no-restricted-syntax -- We need generic type here, and form.item doesnt accept it
          <Form.Item
            name={[notificationType, area]}
            noStyle
            valuePropName={isDisabled ? 'notExistingPropName' : 'checked'}
          >
            <Checkbox aria-label={getAriaLabel()} disabled={isDisabled} />
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default NotificationCheckbox;
